// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  AssetCategory,
} from "./types";

export default {
  requestId: __t.u128(),
  assetId: __t.u64(),
  format: __t.string(),
  get category() {
    return AssetCategory;
  },
  sourceRenditionId: __t.option(__t.u64()),
};
